import styled from 'styled-components';
import { PATHS } from 'AppConstants';

import {
	Container,
	GenericP,
	FlexDiv
} from 'commonStyles';

export const MainWrapper = styled.div(
	({ imgUrl, theme: { down, breakpoints, up } }) => `
			width: 100%;
			margin-top: -80px;
			padding-top: 80px;
			background-attachment: fixed;
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			.mainImg {
				display: none;
			}
			min-height: 666px;
			height: 666px;
			background: linear-gradient(95.43deg, #072833 0.23%, #092C46 100%);
			${up(breakpoints.md)} {
				background: ${imgUrl ? `linear-gradient(to left,rgba(0,0,0,0) 30%,#0b1a2f 98%),linear-gradient(to right,rgba(0,0,0,0) 1%,#0b1a2f8a 100%), url(${imgUrl})` : 'linear-gradient(95.43deg, #072833 0.23%, #092C46 100%)'};
				min-height: 550px;
				height: 550px;
				.mainImg {
					position: fixed;
					top: 0;
					width: 100%;
				}
				background-attachment: fixed;
				background-position: center;
				background-repeat: no-repeat;
				background-size: cover;
			}
}
  `
);

export const MainHeading = styled(GenericP)`
	position: relative;
`;

export const BannerWrapper = styled(Container)(
	({ theme: { down, breakpoints } }) => `
    padding: 50px 0;
    margin: 0 auto;
    padding: 80px 0 0;
    display: flex;
    justify-content: space-between;
    ${down(breakpoints.md)} {
      padding: 25px 16px;
      position: relative;
			flex-direction: column;
			align-item: center;
    }
    .slick-dots {
      top: -70px;
      width: 100%;
      margin: 0;
      list-style: none;
      text-align: center;
      position: absolute;
    }
    .slick-dots li {
      position: relative;
      display: inline-block;
      width: 20px;
      margin: 0 5px;
      padding: 0;
      cursor: pointer;
      background-color: rgba(255,255,255,0.2)
  }
  .slick-next.slick-disabled:before,
  .slick-prev.slick-disabled:before {
      opacity: 0.25;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: 0;
    background: 0 0;
  }
    `
);

export const HeaderWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
		& .highlight-heading {
			color: #ff664b;
		}
  `
);

export const HomepageBannerContainer = styled.div(
	({ theme: { down, breakpoints } }) => `
    display:flex !important;
    align-items: center;
    justify-content: space-between;
    outline: 0;
    ${down(breakpoints.md)} {
      flex-direction: column-reverse;
      align-items: flex-start;
    }
  `
);

export const HomepageBannerLeft = styled.div(
	({ width, theme: { down, breakpoints } }) => `
  width: ${width ? width : 'auto'};
  ${down(breakpoints.tb)} {
    width: 50%;
    margin-right: 25px;
  }
  ${down(breakpoints.md)} {
      width: 100%;
      button{
        margin-top: 60%;
      }
  }
  `
);

export const HomepageBannerRight = styled.div(
	({ theme: { down, breakpoints } }) => `
  width: 40%;
  ${down(breakpoints.md)} {
    width: 100%;
		margin-top: 20px;
  }

`
);

export const SideContentWrap = styled(FlexDiv)(
	({ bg, theme: { down, breakpoints } }) => `
	position: relative;
	background: ${bg || 'linear-gradient(109.37deg, rgba(67, 128, 154, 0.24) 0.83%, rgba(56, 92, 124, 0.144) 100%)'};
  ${down(breakpoints.md)} {
    margin-top: 30px;
  }
`
);

export const BannerDotsWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
  > ul > li {
    &.slick-active {
      width: 50px;
      background-color: #ff664b;
    }
    width: 20px;
    height: 8px;
    margin: 0 5px 0 0;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.06);
    > button {
      &::before {
        display: none;
      }
    }
  }
  ${down(breakpoints.md)} {
    display:none !important;
  }
`
);
